import React from 'react';
import { componentService } from 'js/services/component.service';

export const SportsbookGamingHistory = React.lazy(() => import(/* webpackChunkName: "sportsbook-gaming-history" */ './SportsbookGamingHistory'));

componentService.registerPageComponents({ 'sportsbook-gaming-history': SportsbookGamingHistory });
